import * as React from 'react';
import { useState, useEffect } from 'react';
import useApiRequest from '../../../api/useApiRequest'; // Import the custom hook

import { styled, Dialog, Box, Typography, DialogTitle, IconButton } from '@mui/material/';

import CloseIcon from '@mui/icons-material/Close';

import Slide from '@mui/material/Slide';
import { TransitionProps } from "@mui/material/transitions";

import UserDetailsTable from '../utils/UserDetailsTable';
import { getStatusStyles } from '../utils/getStatusStyles';
import Style from "../../../components/Reusable/Admin/Users/SipocDiagram.module.css";


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));



const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});



interface FileViewPopupProps {
  open: boolean;
  onClose: () => void;
  name?: string;
  id: string;

  date: string;
  status: string;

  sectionTitle: string;
  // apiPath: string; // New prop for the file details API path
  statusApiPath: string; // New prop for the status update API path
  data: any;
}

export default function VisionNStrategyModalAdmin({
  open,
  onClose,
  name,
  id,
 
  date,
  status,

  sectionTitle,
  // apiPath, // Destructure the new prop
  statusApiPath, // Destructure the new prop
  data,
}: FileViewPopupProps) {



  const userName = localStorage.getItem("userName") || undefined;

  // const { loading, error, makeRequest } = useApiRequest(apiPath); // Use the passed apiPath
  const { makeRequest: makeStatusRequest } = useApiRequest(statusApiPath); // Use the passed statusApiPath

  const isStatusApprovedOrReverted = (status: string) => {
    return status === "Approved" || status === "Reverted";
  };


  return (
    <BootstrapDialog
      onClose={onClose}
      aria-labelledby="customized-dialog-title"
      open={open}
      TransitionComponent={Transition}
      sx={{
        '& .MuiDialog-paper': {
          width: '50%', maxWidth: 800, position: "absolute",
          top: "0%",
          right: "0%",
          bottom: "0%",
          height: '100%', margin: 1,
          // padding:'5px 15px'
        }
      }}

    >
      {/* <Typography variant="h6" sx={{ m: 0, p: 1, color: '#000', fontWeight:'600',fontSize:'16px' }} gutterBottom>
        {sectionTitle}
      </Typography> */}
      <DialogTitle sx={{ m: 0, padding:'5px 15px', color: '#000', fontWeight: '600', fontSize: '16px' }} id="customized-dialog-title">
        KPI Details
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={(theme) => ({
          position: 'absolute',
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}
      >
        <CloseIcon />
      </IconButton>


      <Box
        className={Style.scrollableContent}

        sx={{ display: "flex", justifyContent: "space-between", padding:'5px 15px'}}>
        <Box sx={{ flex: 1, pr: 2 }}>
          <Typography variant="h5" className={Style.spoicdatatitle} pt={2}>KPI Name</Typography>
          <Typography className={Style.spoicdatatext}>
            {data?.KPI_name}<br />
          </Typography>


          <Typography variant="h5" className={Style.spoicdatatitle} pt={2}>UOM</Typography>
          <Typography className={Style.spoicdatatext}>
            {data?.UoM}<br />
          </Typography>
          <Typography variant="h5" className={Style.spoicdatatitle} pt={2}>Current Status</Typography>
          <Typography className={Style.spoicdatatext}>
            {data?.currentstatus}<br />
          </Typography>

          <Typography variant="h5" className={Style.spoicdatatitle} pt={2}>Create Date</Typography>
          <Typography className={Style.spoicdatatext}>
            {new Date(data?.created_at).toLocaleDateString()}<br />
          </Typography>
        </Box>
        <Box sx={{ flex: 1, pl: 2 }}>
          <Typography variant="h5" className={Style.spoicdatatitle} pt={2}>Target 2025</Typography>
          <Typography className={Style.spoicdatatext}>
            {data?.target_year === 2025 ? data?.target_year_value : "-"}<br />
          </Typography>
          <Typography variant="h5" className={Style.spoicdatatitle} pt={2}>Target 2030</Typography>
          <Typography className={Style.spoicdatatext}>
            {data?.target_year === 2030 ? data?.target_year_value : "-"}<br />
          </Typography>

          <Typography variant="h5" className={Style.spoicdatatitle} pt={2}>Status</Typography>
          <Typography className={Style.spoicdatatext} sx={{ color: getStatusStyles(data?.status).color }}>
            {data?.status}<br />
          </Typography>

        </Box>


      </Box>

      <UserDetailsTable userName={userName} date={date} data={data}/>
   

   
    </BootstrapDialog>
  );
}